(() => {
  if (window.customElements.get('ergon-price-savings')) {
    return;
  }

  class ErgonPriceSavings extends HTMLElement {
    connectedCallback() {
      this.variantChangeHandler = this.onVariantChange.bind(this);
      this.productForm = document.forms[this.getAttribute('form')];
      this.productForm?.addEventListener('variant:change', this.variantChangeHandler);

      this.renderSavings(
        Number(this.dataset.price),
        Number(this.dataset.compareAtPrice)
      );
    }

    disconnectedCallback() {
      this.productForm?.removeEventListener('variant:change', this.variantChangeHandler);
    }

    onVariantChange(event) {
      const variant = event.detail?.variant;

      if (!variant) {
        this.hidden = true;
        return;
      }

      this.renderSavings(Number(variant.price), Number(variant.compare_at_price));
    }

    renderSavings(price, compareAtPrice) {
      if (
        !Number.isFinite(price) ||
        !Number.isFinite(compareAtPrice) ||
        compareAtPrice <= price ||
        compareAtPrice <= 0
      ) {
        this.hidden = true;
        return;
      }

      const savings = compareAtPrice - price;
      const percentage = Math.round((savings / compareAtPrice) * 100);
      const amountElement = this.querySelector('[data-ergon-saving-amount]');
      const percentageElement = this.querySelector('[data-ergon-saving-percent]');

      if (amountElement) {
        amountElement.textContent = this.formatMoney(savings);
      }

      if (percentageElement) {
        percentageElement.textContent = String(percentage);
      }

      this.hidden = false;
    }

    formatMoney(cents) {
      const locale = this.dataset.locale || document.documentElement.lang || 'en';
      const currency = this.dataset.currency || window.Shopify?.currency?.active || 'USD';
      const currencyDisplay = this.hasAttribute('data-currency-code-enabled') ? 'code' : 'narrowSymbol';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (_error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }
  }

  window.customElements.define('ergon-price-savings', ErgonPriceSavings);
})();
